import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import useFetch from './useFetch'

function useGetFetchedData(paramList) {
  const { pathname } = useLocation()
  const path = pathname.split('/')
  const currentSectionPath = path[path.length - 1]

  const [url, setUrl] = useState(paramList[currentSectionPath])

  const { data, loading, error } = useFetch(url, (resp) => resp.data)

  useEffect(() => {
    const fetchData = async () => {
      if (paramList[currentSectionPath] !== url) {
        const key = await paramList[currentSectionPath]
        setUrl(key)
      }
    }
    fetchData()
  }, [path])

  return { data, loading, error }
}

export default useGetFetchedData
